<kendo-gridlayout class="banner-content-container" [gap]="{ cols: 10 }" [cols]="['auto', 'auto', '1fr']" [align]="{ vertical: 'middle' }">
  <kendo-gridlayout-item class="banner-logo" [col]="1">
    <unity-logo-shared />
  </kendo-gridlayout-item>
  <kendo-gridlayout-item class="banner-profile" [col]="3">
    <unity-panel-context-shared />
  </kendo-gridlayout-item>
</kendo-gridlayout>
